import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba82af66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recoverMessage__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circleWithCheck" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkSymbol" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "authForm__h1" }, "Reset email sent", -1))
const _hoisted_4 = { class: "authForm__p" }
const _hoisted_5 = { class: "authForm__p" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "codeInput__wrapper" }

import { h } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { EmailSupportButton, CodeInputWithTimer } from '@/v2/features/auth';
import { OverlayLayout, LogoTitle, Button } from '@/v2/shared/ui/';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthOverlays',
  props: ['recoverMessageShow', 'codeInputShow', 'show_logo', 'title', 'support_email', 'resend_time', 'num_inputs', 'code_to', 'loading', 'closableCodeForm', 'resendCodeCallback'],
  emits: ['forgotPasswordForm', 'handleVerificationCode', 'clearValidate', 'resendCode', 'codeInputShow'],
  setup(__props, { emit: __emit }) {



const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '24px',
  },
  spin: true,
});

const emit = __emit;


return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.recoverMessageShow)
      ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
          key: 0,
          style: {"border-radius":"9px","background-color":"var(--color-white)"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("b", _hoisted_4, "The link to reset your password has been sent to " + _toDisplayString(__props.code_to), 1),
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode("If you do not receive the password reset message, please check your spam folder or contact us at: "),
                _createElementVNode("a", {
                  href: `mailto:${__props.support_email}`
                }, _toDisplayString(__props.support_email), 9, _hoisted_6)
              ]),
              _createVNode(_unref(Button), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('forgotPasswordForm', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Back")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.codeInputShow)
      ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
          key: 1,
          style: {"border-radius":"9px","background-color":"var(--color-white)"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(LogoTitle), {
                show_logo: __props.show_logo,
                title: __props.title,
                style: {"margin-bottom":"24px"}
              }, null, 8, ["show_logo", "title"]),
              _createVNode(_unref(CodeInputWithTimer), {
                onComplete: _cache[1] || (_cache[1] = (code) => emit('handleVerificationCode', code)),
                to: __props.code_to,
                resend_time: __props.resend_time,
                num_inputs: __props.num_inputs,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (emit('clearValidate'))),
                onResendCode: _cache[3] || (_cache[3] = ($event: any) => (emit('resendCode'))),
                resendCodeCallback: __props.resendCodeCallback
              }, null, 8, ["to", "resend_time", "num_inputs", "resendCodeCallback"]),
              (__props.support_email)
                ? (_openBlock(), _createBlock(_unref(EmailSupportButton), {
                    key: 0,
                    support_email: __props.support_email,
                    style: {"margin-top":"0"}
                  }, null, 8, ["support_email"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.loading)
      ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
          key: 2,
          style: {"border-radius":"9px","background-color":"var(--color-white)","opacity":"0.5"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_spin, { indicator: _unref(indicator) }, null, 8, ["indicator"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})